// Dynamic Mobile Cart Icon Bubble Update
function updateMobileCartBubble() {
  const headerCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
  const count = headerCartBubble ? parseInt(headerCartBubble.textContent.trim(), 10) : 0;

  const mobileCartIcon = document.querySelector('#mobile-cart-icon-bubble');
  if (!mobileCartIcon) return;

  const iconContainer = mobileCartIcon.querySelector('.mobile-bottom-navigation__icon');
  if (!iconContainer) return;

  let mobileCartBubble = iconContainer.querySelector('.mobile-bottom-navigation__cart-bubble');

  if (count > 0) {
    if (!mobileCartBubble) {
      mobileCartBubble = document.createElement('span');
      mobileCartBubble.className = 'mobile-bottom-navigation__cart-bubble';
      iconContainer.appendChild(mobileCartBubble);
    }
    mobileCartBubble.textContent = count;
  } else {
    if (mobileCartBubble) {
      mobileCartBubble.remove();
    }
  }
}

// Wishlist Logic
window.toggleWishlist = function (btn, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  const productHandle = btn.getAttribute('data-product-handle');
  if (!productHandle) return;

  let wishlist = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
  const index = wishlist.indexOf(productHandle);

  if (index > -1) {
    wishlist.splice(index, 1);
    btn.classList.remove('active');
  } else {
    wishlist.push(productHandle);
    btn.classList.add('active');
  }

  localStorage.setItem('wishlist_products', JSON.stringify(wishlist));
  updateWishlistCount();
};

window.updateWishlistCount = function () {
  const wishlist = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
  const count = wishlist.length;

  const wishlistLink = document.querySelector('#mobile-wishlist-link');
  if (!wishlistLink) return;

  const iconContainer = wishlistLink.querySelector('.mobile-bottom-navigation__icon');
  if (!iconContainer) return;

  let wishlistBubble = iconContainer.querySelector('.mobile-bottom-navigation__wishlist-bubble');

  if (count > 0) {
    if (!wishlistBubble) {
      wishlistBubble = document.createElement('span');
      wishlistBubble.className = 'mobile-bottom-navigation__wishlist-bubble';
      iconContainer.appendChild(wishlistBubble);
    }
    wishlistBubble.textContent = count;
  } else {
    if (wishlistBubble) {
      wishlistBubble.remove();
    }
  }
};

function initWishlistButtons() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist_products') || '[]');
  const buttons = document.querySelectorAll('.card__wishlist-btn');
  buttons.forEach((btn) => {
    const productHandle = btn.getAttribute('data-product-handle');
    if (productHandle && wishlist.includes(productHandle)) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
}

function highlightActiveNavigation() {
  const currentPath = window.location.pathname;

  function isCurrent(linkUrl) {
    if (!linkUrl) return false;
    try {
      const url = new URL(linkUrl, window.location.origin);
      const path = url.pathname.replace(/\/$/, '');
      const normCurrent = currentPath.replace(/\/$/, '');

      if (path === normCurrent) return true;

      if ((path === '/account' || path === '/account/login') && normCurrent.startsWith('/account')) {
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  const items = document.querySelectorAll('.mobile-bottom-navigation__item');
  items.forEach((item) => {
    if (isCurrent(item.getAttribute('href'))) {
      item.classList.add('is-active');
      const wishlistContainer = item.closest('.bottom-wishlist');
      if (wishlistContainer) {
        wishlistContainer.classList.add('is-active');
      }
    } else {
      item.classList.remove('is-active');
      const wishlistContainer = item.closest('.bottom-wishlist');
      if (wishlistContainer) {
        wishlistContainer.classList.remove('is-active');
      }
    }
  });
}

function initMobileCartDrawerTrigger() {
  const mobileCartIcon = document.querySelector('#mobile-cart-icon-bubble');
  if (!mobileCartIcon) return;

  mobileCartIcon.setAttribute('role', 'button');
  mobileCartIcon.setAttribute('aria-haspopup', 'dialog');

  mobileCartIcon.addEventListener('click', (event) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      event.preventDefault();
      cartDrawer.open(mobileCartIcon);
    }
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', () => {
  updateMobileCartBubble();
  updateWishlistCount();
  initWishlistButtons();
  highlightActiveNavigation();
  initMobileCartDrawerTrigger();

  // Set up cart MutationObserver
  const headerCartIcon = document.getElementById('cart-icon-bubble');
  if (headerCartIcon) {
    const cartObserver = new MutationObserver(updateMobileCartBubble);
    cartObserver.observe(headerCartIcon, { childList: true, subtree: true });
  }

  // Set up wishlist MutationObserver for dynamic content
  const wishlistObserver = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        shouldInit = true;
        break;
      }
    }
    if (shouldInit) {
      initWishlistButtons();
    }
  });
  wishlistObserver.observe(document.body, { childList: true, subtree: true });
});

// Fallback / Immediate execution if already loaded
if (document.readyState !== 'loading') {
  updateMobileCartBubble();
  updateWishlistCount();
  initWishlistButtons();
  highlightActiveNavigation();
  initMobileCartDrawerTrigger();
}
